import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#101828",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M11.083 25.667h5.833M9.333 2.334h9.333m-4.667 3.5v-3.5M4.666 14.001h18.667m-3.5 8.166 1.75 3.5m-13.417-3.5-1.75 3.5m3.5-7.583h.012m8.155 0h.011m-7.828 4.083h7.467c1.96 0 2.94 0 3.689-.381a3.5 3.5 0 0 0 1.53-1.53c.38-.748.38-1.729.38-3.689v-5.133c0-1.96 0-2.94-.38-3.689a3.5 3.5 0 0 0-1.53-1.53c-.749-.381-1.73-.381-3.69-.381h-7.466c-1.96 0-2.94 0-3.689.381a3.5 3.5 0 0 0-1.53 1.53c-.381.749-.381 1.729-.381 3.689v5.133c0 1.96 0 2.94.381 3.69a3.5 3.5 0 0 0 1.53 1.529c.749.381 1.729.381 3.689.381Zm.233-4.083a.583.583 0 1 1-1.166 0 .583.583 0 0 1 1.166 0Zm8.167 0a.583.583 0 1 1-1.167 0 .583.583 0 0 1 1.167 0Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "train"}) } }